export default __webpack_public_path__ + "static/media/Landing_Logo_Fecoer.274fa621.png";